module.exports = __webpack_public_path__ + "media/images/frontend/pages/home-2-1241f81fe9167e60541c6d008b6e0b93.jpg";